export const sheetConstants = {
  maxUndo: 10,
  cell: {
    font: {
      size: 14,
      family: 'Arial',
    },
  },
};
